import requestProvider from "./axiosHandler";

const getAllPurchase = () => {
    return requestProvider
        .get('/purchase/get-all')
}

const createPurchase = (list) => {
    return requestProvider
        .post('/purchase',list)
}

const closePurchase = (list) => {
    return requestProvider
        .post('/purchase/complete-purchase', list)
}

const createPurchaseFromCrud = (list) => {
    return requestProvider
        .post('/purchase-new', {
            quantity: list.quantity,
            bid: null,
            stock: {
                id: list.stockId
            },
            supplier: {
                id: list.supplierId
            }
        })
}

const getPurchaseById = (id) => {
    return requestProvider
        .get(`/purchase/${id}`)
}

const updatePurchase = (list) => {
    return requestProvider
        .put(`/purchase`, list)
}

const deletePurchase = (id) => {

    return requestProvider
        .delete(`/purchase/${id}`)
}

const getPurchaseDetail = (id) => {
    return requestProvider
        .get(`purchase/detail/${id}`)

}

const purchaseFilter = (list) => {
    return requestProvider
        .post('/purchase/filtered', list)
}

const getAllCompletedPurchases = () => {
    return requestProvider
        .get('/purchase/get-all/1')
}

const getPurchasesAsSelect = () => {
    return requestProvider
        .get('/purchase/select')
}

export {
    purchaseFilter,
    closePurchase,
    getAllPurchase,
    createPurchase,
    createPurchaseFromCrud,
    getPurchaseById,
    updatePurchase,
    deletePurchase,
    getPurchaseDetail,
    getAllCompletedPurchases,
    getPurchasesAsSelect
}